import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import {
  MARK_BUTTONS,
  isButtonActive,
  executeButton,
} from '../EditorToolbar/toolbarButtons';
import styles from './EditorBubbleMenu.module.css';

interface EditorBubbleMenuProps {
  editor: Editor;
}

export default function EditorBubbleMenu({ editor }: EditorBubbleMenuProps) {
  const activeStates = useEditorState({
    editor,
    selector: ({ editor: e }) =>
      MARK_BUTTONS.reduce(
        (acc, btn) => {
          acc[btn.key] = e ? isButtonActive(e, btn) : false;
          return acc;
        },
        {} as Record<string, boolean>
      ),
  });

  return (
    <BubbleMenu
      editor={editor}
      options={{ placement: 'top', offset: 8 }}
      className={styles.bubbleMenu}
    >
      {MARK_BUTTONS.map((button) => {
        const isActive = activeStates?.[button.key] ?? false;

        return (
          <button
            key={button.key}
            type="button"
            className={`${styles.button} ${isActive ? styles.active : ''}`}
            onClick={() => executeButton(editor, button)}
            onMouseDown={(e) => e.preventDefault()}
            aria-label={button.label}
            aria-pressed={isActive}
          >
            <button.Icon />
          </button>
        );
      })}
    </BubbleMenu>
  );
}
